import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackImage?: string;
  hasBlurEffect?: boolean;
  clickAnimation?: boolean;
}

const MyImage = ({
  width = "100%",
  height = "100%",
  hasBlurEffect = true,
  src,
  className = "",
  ...rest
}: IProps) => {
  const [hasError, setHasError] = useState(false);

  return (
    <LazyLoadImage
      src={hasError ? "/images/fallBack.webp" : src || "/images/fallBack.webp"}
      effect={hasBlurEffect ? "blur" : undefined}
      threshold={100}
      width={width}
      height={height}
      className={className}
      useIntersectionObserver={true}
      onError={() => setHasError(true)}
      loading="lazy"
      {...rest}
    />
  );
};

export default MyImage;
